import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API_BASE, withCredentials: true });

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};


export const getLeagues = () => client.get("/leagues").then((r) => r.data);

export const getGames = (params) => client.get("/games", { params }).then((r) => r.data);

export const getGameDetail = (gameId) => client.get(`/games/${gameId}`).then((r) => r.data);

export const getGamePredictions = (gameId) => client.get(`/games/${gameId}/predictions`).then((r) => r.data);

export const getBetEvaluation = (gameId) => client.get(`/games/${gameId}/bet-evaluation`).then((r) => r.data);

export const getSettings = () => client.get("/settings").then((r) => r.data);

export const updateSettings = (payload) => client.put("/settings", payload).then((r) => r.data);

export const getPipelineStatus = () => client.get("/system/pipeline-status").then((r) => r.data);

export const getDataStatus = () => client.get("/admin/data-status").then((r) => r.data);

export const getIngestionLogs = (params) => client.get("/admin/ingestion-logs", { params }).then((r) => r.data);

export const ingestTeams = (payload) => client.post("/admin/ingest/teams", payload).then((r) => r.data);

export const ingestRosters = (payload) => client.post("/admin/ingest/rosters", payload).then((r) => r.data);

export const ingestDailyUpdate = (payload) => client.post("/admin/ingest/daily-update", payload).then((r) => r.data);

export const ingestHistorical = (payload) => client.post("/admin/ingest/historical", payload).then((r) => r.data);

export const ingestPlayerBios = (payload) => client.post("/admin/ingest/player-bios", payload).then((r) => r.data);

export const getSchedulerStatus = () => client.get("/admin/scheduler-status").then((r) => r.data);

export const getFeatureCoverage = (params) => client.get("/admin/features/coverage", { params }).then((r) => r.data);

export const buildFeatureSnapshotsForDate = (payload) =>
  client.post("/admin/features/build-snapshots-for-date", payload).then((r) => r.data);

export const getFeatureAudit = (gameId, params) =>
  client.get(`/admin/features/audit/${gameId}`, { params }).then((r) => r.data);

export const checkAdminSession = () => client.get("/admin-session/status").then((r) => r.data.authenticated);

export const adminLogin = (adminApiKey) =>
  client.post("/admin-session/login", { admin_api_key: adminApiKey }).then((r) => r.data);

export const adminLoginWithPassword = (email, password) =>
  client.post("/admin-session/login-password", { email, password }).then((r) => r.data);

export const adminLogout = () => client.post("/admin-session/logout").then((r) => r.data);

export const getSubscribers = () => client.get("/admin/subscribers").then((r) => r.data);

export const setCompAccess = (userId, grant) =>
  client.post(`/admin/subscribers/${userId}/comp-access`, { grant }).then((r) => r.data);

export const getGameIntelligence = (gameId, params) => client.get(`/games/${gameId}/intelligence`, { params }).then((r) => r.data);

export const getNflPreview = () => client.get("/nfl/preview").then((r) => r.data);
export const getNflPerformance = () => client.get("/nfl/performance").then((r) => r.data);

export const getNbaPreview = (date) => client.get("/nba/preview", { params: date ? { date } : {} }).then((r) => r.data);
export const getNbaBestBets = () => client.get("/nba/best-bets").then((r) => r.data);

export const getGamePrediction = (gameId, params) => client.get(`/games/${gameId}/prediction`, { params }).then((r) => r.data);

export const getBestBets = () => client.get("/best-bets").then((r) => r.data);

export const getTeams = (params) => client.get("/teams", { params }).then((r) => r.data);

export const getLineMovementLeagues = () => client.get("/line-movement/leagues").then((r) => r.data);

export const getLineMovement = (params) => client.get("/line-movement", { params }).then((r) => r.data);

export const getLineMovementDetail = (eventId) => client.get(`/line-movement/${eventId}`).then((r) => r.data);

export const getKalshiBigMoney = (params) => client.get("/kalshi/big-money", { params }).then((r) => r.data);

export const getKalshiTwoSidedWarnings = (params) => client.get("/kalshi/two-sided-warnings", { params }).then((r) => r.data);

export const requestDownloadLink = (email) => client.post("/downloads/request-link", { email }).then((r) => r.data);

export const registerUser = (payload) => client.post("/auth/register", payload).then((r) => r.data);

export const loginUser = (payload) => client.post("/auth/login", payload).then((r) => r.data);

export const logoutUser = () => client.post("/auth/logout").then((r) => r.data);

export const getMe = () => client.get("/auth/me").then((r) => r.data);

export const exchangeBbHandoff = (code) => client.post("/bb/exchange-handoff", { code }).then((r) => r.data);

export const getBbPendingLink = () => client.get("/bb/pending-link").then((r) => r.data);

export const confirmBbLink = () => client.post("/bb/confirm-link").then((r) => r.data);

export const createCheckoutSession = () =>
  client.post("/payments/checkout", { origin_url: window.location.origin }).then((r) => r.data);

export const createPortalSession = () =>
  client.post("/payments/portal", { origin_url: window.location.origin }).then((r) => r.data);

export const getPaymentStatus = (sessionId) => client.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const forgotPassword = (email) =>
  client.post("/auth/forgot-password", { email, origin_url: window.location.origin }).then((r) => r.data);

export const resetPassword = (token, newPassword) =>
  client.post("/auth/reset-password", { token, new_password: newPassword }).then((r) => r.data);

export default client;
